module.exports = __webpack_public_path__ + "img/screen1.7a7e9b78.png";